<template>
    <!-- <ScreenAdapter> -->
    <div>
        <div class="header-container">
            <div class="header-content">
                <div class="info-box">
                    <div class="school-logo">
                        <img src="../../../assets/custom/clnyy/logo-img.png">
                    </div>
                </div>
                <div class="handle-box">
                    <div :class="['eol-right-user', menuOpen ? 'up' : 'down']" @mouseleave="menuOpen = false"
                        @click="menuOpen = !menuOpen">
                        <div class="login-btn" v-if="!loginUserInfo || loginUserInfo.school_code != school_code"
                            @click="handleLogin()">登录</div>
                        <template v-else>
                            <div class="mine-lines">
                                <div class="user-imgs-box"></div>
                                <span>{{ loginUserInfo && loginUserInfo.name ? loginUserInfo.name : loginUserInfo &&
                                    loginUserInfo.username}}</span>
                            </div>
                            <ul @mouseleave="menuOpen = false" class="eol-submine-box">
                                <template v-if="services.DEPLOY !== 'hzvtc'">
                                <li class="submine-items">
                                    <a :href="`${services.LOGIN_SERVER}/${school_code}/worker`">信息服务中心</a>
                                </li>
                                <li class="submine-items">
                                    <a :href="`${services.LOGIN_SERVER}/${school_code}/userInfo`">个人信息</a>
                                </li>
                                <li class="submine-items">
                                    <a :href="`${services.LOGIN_SERVER}/${school_code}/editPassword`">修改密码</a>
                                </li>
                                </template>
                                <li class="submine-items" @click="logoutEvents">
                                    <a href="javascript:;">退出登录</a>
                                </li>
                            </ul>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-container" ref="container">
            <div class="banner-swiper">
                <template>
                    <template v-if="bannerList && bannerList.length > 1">
                        <swiper :options="swiperOption1">
                            <swiper-slide class="thumb-image" v-for="img, index in bannerList" :key="index"
                                :style="`background:url(${img}) no-repeat center/cover;`">
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-pagination-1"></div>
                    </template>
                    <div v-else class="thumb-image" v-for="img, index in bannerList" :key="index"
                        :style="`background:url(${img}) no-repeat center/cover;`"></div>
                </template>

            </div>
            <div class="ssap-box container" id="section1">
                <div class="header"></div>
                <div class="content" ref="ref-1">
                    <div class="hdbj">
                        <div class="label">◆ 活动背景</div>
                        <div class="con">
                            为充分发挥地区专业科普资源，促进中小学生对智慧农业的进一步认识，激发学生对于农业科学的兴趣和实际动手能力，北京市朝阳区农业农村局、北京市朝阳区来广营乡人民政府联合专业科普团队依托朝来农艺园国家数字农业创新应用基地，举办朝阳区中小学生“智慧农业杯”科普活动。
                        </div>
                    </div>
                    <div class="hdjj">
                        <div class="label">◆ 活动简介</div>
                        <div class="con">
                            结合中小学暑期实践时间，于6月至9月开展朝阳区中小学生“智慧农业杯”科普活动。比赛采用线上线下双线办赛模式，设置预热招募、初选、复选和总决选四个阶段，涵盖培训、参观实践、评选、专家论坛等多环节。初选和复选阶段，以线上答题方式进行，同期开展“线上培训+线下实践”，以赛事为牵引，增强青少年对智慧农业和乡村振兴重要性的认识，实现智慧农业破圈传播。总决选于9月开展，同期开展专家论坛。
                        </div>
                    </div>
                    <div class="zzjg">
                        <div class="label">◆ 组织机构</div>
                        <div class="con">
                            【 主办单位
                            】&nbsp;&nbsp;&nbsp;北京市朝阳区农业农村局、北京市朝阳区来广营乡人民政府&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br>【
                            指导单位 】&nbsp;&nbsp;&nbsp;北京市朝阳区科学技术协会<br>【 承办单位 】&nbsp;&nbsp;&nbsp;北京朝来农艺园、教育在线 |
                            北京中教互联教育科技有限公司
                        </div>
                    </div>
                    <div class="sjap">
                        <div class="label">◆ 时间安排</div>
                        <div class="con">
                            <div class="current-box">
                                <div @click="currentShow(1)"
                                    :class="['current-item', dayCurrent == 1 ? 'active' : '', dayStatus == 1 ? 'flag' : '']">
                                    <div class="name">报名阶段</div>
                                    <div class="date">（ 6月10日 ~ 7月8日 ）</div>
                                </div>
                                <div @click="currentShow(2)"
                                    :class="['current-item', dayCurrent == 2 ? 'active' : '', dayStatus == 2 ? 'flag' : '']">
                                    <div class="name">初 选</div>
                                    <div class="date">（ 7月9日 ~ 7月12日 ）</div>
                                </div>
                                <div @click="currentShow(3)"
                                    :class="['current-item', dayCurrent == 3 ? 'active' : '', dayStatus == 3 ? 'flag' : '']">
                                    <div class="name">复 选</div>
                                    <div class="date">（ 7月13日 ~ 9月6日 ）</div>
                                </div>
                                <div @click="currentShow(4)"
                                    :class="['current-item', dayCurrent == 4 ? 'active' : '', dayStatus == 4 ? 'flag' : '']">
                                    <div class="name">总决选</div>
                                    <div class="date">（ 9月20日 ）</div>
                                </div>
                            </div>
                            <div class="con-box" v-show="dayCurrent">
                                <div class="current-content bmjd" v-show="dayCurrent == 1">
                                    <div class="line-type-1">
                                        <div class="sub-label">报名对象</div>
                                        <div class="text">中小学生</div>
                                    </div>
                                    <div class="line-type-1">
                                        <div class="sub-label">组别设置</div>
                                        <div class="text">小学低年级组（1-3年级）；小学高年级组（4-6年级）；初中组</div>
                                    </div>
                                    <div class="line-type-2">
                                        <div class="l">
                                            <div class="name">线上报名</div>
                                            <div class="href">
                                                <span>https://www.wjx.top/vm/hK7b1qn.aspx#</span>
                                                <a href="https://www.wjx.top/vm/hK7b1qn.aspx#" target="_blank">访问</a>
                                            </div>
                                            <div class="copy" @click="copyHref('https://www.wjx.top/vm/hK7b1qn.aspx#')">
                                                复制链接
                                            </div>
                                        </div>
                                        <div class="r">
                                            <img src="../../../assets/custom/clnyy/qrcode.jpg">
                                            <span>或扫描二维码<br>立即报名</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="current-content type-2" v-show="dayCurrent == 2">
                                    <div class="time-line">
                                    </div>
                                    <div class="time-items">
                                        <div class="items">
                                            <div class="date">6月22日、7月8日</div>
                                            <div class="name">智慧农场实地参观讲解</div>
                                        </div>

                                        <div class="items">
                                            <div class="date">7月9日-7月11日</div>
                                            <div class="name">线上答题</div>
                                        </div>

                                        <div class="items">
                                            <div class="date">7月12日</div>
                                            <div class="name">发布复选名单及通知</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="current-content type-2" v-show="dayCurrent == 3">
                                    <div class="time-line">
                                    </div>
                                    <div class="time-items">
                                        <div class="items">
                                            <div class="date">7月13日-7月14日</div>
                                            <div class="name">智慧农业实地体验活动</div>
                                        </div>

                                        <div class="items">
                                            <div class="date">7月15日-8月24日</div>
                                            <div class="name">提交复选作品</div>
                                        </div>

                                        <div class="items">
                                            <div class="date">9月6日</div>
                                            <div class="name">发布总决选名单及通知</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="current-content type-2 pt93" v-show="dayCurrent == 4">
                                    <div class="time-name">9月20日</div>
                                    <div class="time-line"></div>
                                    <div class="time-items">
                                        <div class="items">
                                            <div class="name-2">总决选</div>
                                        </div>

                                        <div class="items">
                                            <div class="name-2">智慧农业专家论坛</div>
                                        </div>

                                        <div class="items">
                                            <div class="name-2">智慧农业现场活动体验日</div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="hdsh">
                        <div class="label">◆ 活动收获</div>
                        <div class="con"></div>
                    </div>
                </div>
            </div>
            <div class="dsdt-box container section" id="section2">
                <div class="header"></div>
                <div class="content">
                    <!-- 活动报道暂时没有新闻，隐藏 -->
                    <div class="select-box">
                        <div :class="['select-item', dsdtActive == 0 ? 'active' : '']" @click="changedsDtActive(0)">大赛通知
                        </div>
                        <div :class="['select-item', dsdtActive == 1 ? 'active' : '']" @click="changedsDtActive(1)">活动报道
                        </div>
                    </div>
                    <template>
                        <div class="content-box" v-if="dsdtActive == 0">
                            <div class="aside">
                                <div class="aside-header"></div>
                                <div class="aside-content">
                                    <div class="aside-scroll">
                                        <div :class="['item', dsdtAsideActive == index ? 'active' : '']"
                                            v-for="item, index in dsdtData" :key="index"
                                            @click="changeAsideActive(index)">{{ item.name }}</div>
                                    </div>
                                </div>
                            </div>
                            <div ref="ref-2"></div>

                            <div class="cont">
                                <div v-html="dsdtData[dsdtAsideActive].html" id="dsdtScroll1"></div>
                            </div>

                        </div>

                        <div class="content-box" v-else>
                            <div class="aside">
                                <div class="aside-header"></div>
                                <div class="aside-content">
                                    <div class="aside-scroll">
                                        <div :class="['item', dsdtAsideActive == index ? 'active' : '']"
                                            v-for="item, index in hdbdData" :key="index"
                                            @click="changeAsideActive(index)">{{ item.name }}</div>
                                    </div>
                                </div>
                            </div>
                            <div ref="ref-2"></div>

                            <div class="cont">
                                <div v-html="hdbdData[dsdtAsideActive].html" id="dsdtScroll2"></div>
                            </div>

                        </div>
                    </template>

                </div>
            </div>
            <div class="zxkc-box container section" id="section3">
                <div class="header" ref="ref-3"></div>
                <div class="cate-box" v-if="category != {}">
                    <div :class="['cate-list-item', `level-${index + 1}`]" v-for="(item, key, index) in category"
                        :key="index">
                        <div class="cate-item">
                            <template v-for="(itm, idx) in category[key]">
                                <div :class="[screenInfo[`level_${index + 1}`] == itm.id ? 'active' : '', 'tag']" :key="idx"
                                    @click="screenCourse(itm, idx, key, index + 1)">
                                    {{ itm.name }}
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

                <div class="class-lists">
                    <div class="class-box" v-for="item, index in courseData" :key="index" @click="jumpDetail(item)">
                        <div class="img">
                            <img :src="item.photo" />
                        </div>
                        <div class="txt">
                            <div class="title">{{ item.name }}</div>
                            <div class="num">
                                <div class="courseFont"></div>
                                课程总时长：{{ item.total_time }}
                            </div>
                        </div>
                    </div>

                    <div class="sub-visibility"></div>
                    <div class="sub-visibility"></div>
                    <div class="sub-visibility"></div>
                </div>
            </div>
            <div class="background">
                <div class="nyyjs-box container section" id="section4">
                    <div class="header"></div>
                    <div class="content" ref="ref-4">
                        <div class="swiper-imgs">
                            <swiper :options="swiperOption2">
                                <swiper-slide class="thumb-image" v-for="img, index in jsBannerList" :key="index"
                                    :style="`background:url(${img}) no-repeat center/cover;`">
                                </swiper-slide>
                            </swiper>
                            <template v-if="jsBannerList && jsBannerList.length > 1">
                                <div class="swiper-pagination-2"></div>
                                <div class="swiper-button-prev"></div>
                                <div class="swiper-button-next"></div>
                            </template>
                        </div>
                        <div class="text">
                            <div class="text-scroll">
                                <p>朝来农艺园始建于1996年，是北京首批都市农业项目，总面积239亩，耕种面积63亩，其中1栋连栋温室，19栋日光温室，现有种植品种45种，是集高科技生产、净菜加工、休闲娱乐、科普教育为一体的农业公园。园区先后获得<b>“国家数字农业创新应用基地”、“全国农业旅游示范点”、“国家级农业标准化示范基地”、“国家级生态农场全国科普教育基地”、“北京市爱国主义教育基地”、“青少年教育实践基地”、“中小学社会大课堂资源单位”</b>等多项荣誉称号。
                                </p>
                                <p>基地通过国产化物联网、云计算、数据处理及智能控制等技术，打造了园区的农业物联云平台及智能管理系统。</p>
                                <p>此外，基地还设置了参观展示区、育苗区、种植区、设备间等区域供生产实践使用。</p>
                            </div>
                        </div>
                    </div>
                    <div class="list-imgs">
                        <div :class="['item', item.showType ? (item.showType == 1 ? 'up' : 'down') : '']"
                            v-for="item, index in nyyjsData" :key="index">
                            <!-- <img :src="item.thumb_image"> -->
                            <div class="img" :style="`background-image:url(${item.thumb_image})`"></div>
                            <div class="text">{{ item.text }}</div>
                            <div class="more" @click="handleMore(index)" v-if="item.hasMore">
                                {{ item.showType == 1 ? '展开+' : '收起-' }}
                            </div>
                        </div>
                    </div>
                    <div class="description">
                        未来，朝来农艺园将以科技创新、品牌打造、农旅结合为发展方向<br>
                        秉承绿色生态生产理念，努力打造成为北京市乃至全国都市型现代农业和数字农业的示范典型
                    </div>
                </div>
                <div class="wqhd-box container section" id="section5">
                    <div class="header"></div>
                    <div class="content">
                        <div class="intro">
                            <div class="intro-background"></div>
                            <div class="intro-text">
                                依托朝来农艺园的自然资源与全自动化智能平台，融合未来农业科普、体验、自然艺术创作、自然互动游戏、创新科技活动、创意艺术创组等元素，北京朝来农艺园已打造出一套高质量数字农业实践课程。
                            </div>
                        </div>
                        <div class="intro-idea">
                            <div class="label"></div>
                            <div class="lists">
                                <div class="item">
                                    <div class="name">
                                        <b>多学科融合</b>
                                        <b>核心知识再构建</b>
                                    </div>
                                    <div class="text">内容涵盖信息技术课、劳动课、科学课、
                                        生物课、化学课、美术课等多学科知识内容</div>
                                </div>

                                <div class="item">
                                    <div class="name">
                                        <b>多重教育属性</b>
                                        <b>引领心智培养</b>
                                    </div>
                                    <div class="text">集劳动教育、科学教育、STEAM教育、艺术教育于一体的系列课程</div>
                                </div>

                                <div class="item">
                                    <div class="name">
                                        <b>集“四会五感”</b>
                                        <b>促“三全育人”</b>
                                    </div>
                                    <div class="text">在视、听、嗅、味、触等多重感官刺激下感受数字农业魅力。凝聚起实现中国梦科技强国的磅礴青春力量</div>
                                </div>
                            </div>
                        </div>
                        <div class="intro-video">
                            <div class="video-box">
                                <video id="video" poster="../../../assets/custom/clnyy/dataImgs/video-cover.jpg"
                                    controlslist="nodownload" controls
                                    src="http://1500004122.vod2.myqcloud.com/43839479vodtranscq1500004122/80c4c8f71253642697758233997/v.f100030.mp4"></video>
                            </div>
                            <div class="text-content">
                                <div class="select-box">
                                    <div v-for="item, index in hdfcData" :key="index"
                                        :class="['item', hdfcActive == index ? 'active' : '']"
                                        @click="handleHdfcActive(index)">{{
                                        item.name }}</div>
                                </div>
                                <div class="word-box" ref="ref-5" v-html="hdfcData[hdfcActive].html"> </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <Footer></Footer>

        <div :class="['fixed-slider', isFixed ? 'fixed' : '']">
            <div class="slider-header"></div>
            <div class="slider-content">
                <a @click="scrollToSection('1')" :class="['slider-item', isFixedId == 1 ? 'active' : '']">赛事安排</a>
                <a @click="scrollToSection('2')" :class="['slider-item', isFixedId == 2 ? 'active' : '']">大赛动态</a>
                <a @click="scrollToSection('3')" :class="['slider-item', isFixedId == 3 ? 'active' : '']">科普课程</a>
                <a @click="scrollToSection('4')" :class="['slider-item', isFixedId == 4 ? 'active' : '']">朝来农艺园介绍</a>
                <a @click="scrollToSection('5')" :class="['slider-item', isFixedId == 5 ? 'active' : '']">往期活动风采</a>
            </div>
        </div>
    </div>
    <!-- </ScreenAdapter> -->
</template>
<script>
import { mapState, mapActions } from 'vuex';
import utils from '../../../config/utils';
import services from '../../../config/services';
import clnyyData from '../../../assets/js/clnyyData'
import Footer from "../../../components/StudyFooter.vue"
import { Message } from 'element-ui';
// import ScreenAdapter from '../../../components/ScreenAdapter.vue';
export default {
    data() {
        return {
            bannerList: clnyyData.bannerList, // 顶部轮播图
            jsBannerList: clnyyData.jsBannerList, // 农艺园介绍轮播图
            swiperOption1: {
                loop: true,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: ".swiper-pagination-1",
                    clickable: true,
                }
            },
            swiperOption2: {
                loop: true,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: ".swiper-pagination-2",
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },

            dsdtActive: 0,
            dsdtAsideActive: 6,
            dsdtData: clnyyData.dsdtData, // 大赛动态数据
            hdbdData: clnyyData.hdbdData, // 活动报道数据
            hdfcActive: 0,
            hdfcData: clnyyData.hdfcData, // 活动风采数据
            hdfcActiveTimer: null,
            nyyjsData: clnyyData.nyyjsData, // 农艺园介绍数据
            school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
            search: false, // 是否显示搜索框
            services,
            menuOpen: false,
            activeAnchor: "",
            windowHeight: document.documentElement.clientHeight, // 可视窗口高度
            isFixedId: 1, // 当前固定的菜单id
            isFixed: false,
            courseData: [],
            studyBan: false,
            dayStatus: "",
            dayCurrent: "",
            category: {},
            screenInfo: {
                level_1: ""
            },
            category_id: 0,
        }
    },
    components: {
        Footer,
        // ScreenAdapter
    },
    mounted() {
        // $('video').bind('contextmenu',function() { return false; })
        document.getElementById("video").addEventListener("contextmenu", this.removeContextMenu)
        this.getAppsLoginUserInfo()
        this.getLoginSchoolInfo({ school_code: this.school_code }).then(res => {
            if (res.code == '0000') utils.setTitle(document.title + "-" + res.data.school_name)
        });

        this.getCategory()
        this.getCourseList()
        this.autoHdfcActive()
        this.getCurrentDateStatus()
        window.addEventListener("scroll", this.handleScroll, true)
        // 滚动条定位到选中的item
        this.$nextTick(function () {
            function scrollToElement(className, container) {
                var elements = container.querySelectorAll(className);
                if (elements && elements.length > 0) {
                    var element = elements[0];
                    container.scrollTop = element.offsetTop - container.offsetTop;
                }
            }

            var container = document.querySelector('.aside-scroll');
            scrollToElement('.item.active', container);
        })
    },
    destroyed() {
        clearInterval(this.hdfcActiveTimer)
        window.removeEventListener("scroll", this.handleScroll)
        document.getElementById("video").removeEventListener("contextmenu", this.removeContextMenu)
    },
    methods: {
        ...mapActions(["requestAppsLogout", 'getAppsLoginUserInfo', "getLoginSchoolInfo"]),

        // 根据分类筛选课程
        async screenCourse(item, index, key, level) {
            this.screenInfo[`level_${level}`] = item.id
            let items = { id: item.id, index, root_id: item.root_id }
            this.screenInfo = { ...this.screenInfo, ...items }
            this.category_id = item.category_id || item.id
            this.deleteLevel(level, item.id)
            await this.getCategory(item, level)
            await this.getCourseList(item, level)
        },

        async getCategory(val, level) {
            let { data } = await services.getCategoryList({ root_id: this.category_id ? this.category_id : 363, school_code: "100044" })
            if (data && data.length > 0) {
                this.$set(this.category, (val && val.id) ? (`${level}_${val.id}`) : '_', [{ name: "全部", id: "", root_id: data[0].root_id }, ...data])
                this.screenInfo[`level_${level + 1}`] = ""
            }
        },

        // 删除大于当前点击的等级
        deleteLevel(level, id) {
            for (let key in this.category) {
                let levels = key.split("_")[0]
                if (levels >= level) delete this.category[key]
            }
        },

        changedsDtActive(index) {
            this.dsdtAsideActive = 0
            this.dsdtActive = index
            this.$nextTick(() => {
                // setTimeout(function () {
                document.getElementById("dsdtScroll1") ? document.getElementById("dsdtScroll1").scrollTop = 0 : ""
                document.getElementById("dsdtScroll2") ? document.getElementById("dsdtScroll2").scrollTop = 0 : ""
                // }, 300)
            })
        },
        changeAsideActive(index) {
            this.dsdtAsideActive = index
            this.$nextTick(() => {
                // setTimeout(function () {
                document.getElementById("dsdtScroll1") ? document.getElementById("dsdtScroll1").scrollTop = 0 : ""
                document.getElementById("dsdtScroll2") ? document.getElementById("dsdtScroll2").scrollTop = 0 : ""
                // }, 300)
            })
        },
        removeContextMenu(event) {
            event.preventDefault();
        },
        handleMore(ind) {
            this.nyyjsData[ind].showType = this.nyyjsData[ind].showType == 1 ? 2 : 1
        },
        // 获取当前日期，选中时间安排阶段
        getCurrentDateStatus() {
            const nowYear = new Date().getFullYear()
            const nowMonth = new Date().getMonth() + 1
            const nowDay = new Date().getDate()
            const nowDate = nowMonth + '-' + nowDay;
            if (nowYear > 2024) {
                this.dayStatus = 4
                this.dayCurrent = 4
                return
            }
            let dateObj = {}
            let object = {
                1: { startDateStr: "6-10", endDateStr: "7-8" },
                2: { startDateStr: "7-9", endDateStr: "7-12" },
                3: { startDateStr: "7-13", endDateStr: "9-6" },
                4: { startDateStr: "9-7", endDateStr: "9-20" },
            }
            for (let key in object) {
                let element = object[key];
                let startDateStr = element.startDateStr
                let endDateStr = element.endDateStr
                let startDate = new Date(startDateStr.replace(/-/g, '/'));
                let endDate = new Date(endDateStr.replace(/-/g, '/'));
                if (startDate > endDate) {
                    throw new Error('起始日期不能晚于结束日期');
                }
                let dateArray = [];
                let currentDate = new Date(startDate);
                while (currentDate <= endDate) {
                    let formattedDate = `${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
                    dateArray.push(formattedDate);
                    currentDate.setDate(currentDate.getDate() + 1);
                }
                dateObj[key] = dateArray
            }
            let result
            for (const key in dateObj) {
                if (dateObj[key].includes(nowDate)) {
                    result = key
                    this.dayCurrent = key
                }
            }
            if (result) {
                this.dayStatus = result
            } else {
                if (nowMonth <= 6 && nowDay <= 10) {
                    this.dayStatus = 1
                    this.dayCurrent = 1
                } else {
                    this.dayStatus = 4
                    this.dayCurrent = 4
                }
            }
        },
        currentShow(num) {
            this.dayCurrent = num
        },
        // 复制链接
        copyHref(href) {
            const input = document.createElement('input');
            input.value = href;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            Message.success("复制成功")
        },
        // 获取课程列表
        getCourseList(item) {
            let root_id = ""
            if (item && item.name == '全部') {
                root_id = item.root_id
            } else {
                root_id = this.screenInfo.id
            }

            services.getCourseList({ category_id: root_id, school_code: "100044", class_name: "2024年智慧农业杯朝阳区中小学生农业科普活动", page: 1, size: 100 }).then(res => {
                if (res.code == '0000') {
                    this.courseData = res.data.items
                    // 如果已经判断过是否有权限学习，就不用再次请求了
                    if (!this.studyStatus) {
                        this.studyStatus = true
                        if (this.courseData && this.courseData.length > 0) {
                            services.getCourseDetails({ id: this.courseData[0].id }).then(res => {
                                // 未加入班级，禁止学习 
                                if (res.data && res.data.remaining_day == 0 || res.data.status == 3) {
                                    this.studyBan = true
                                }
                            })
                        }
                    }

                }
            })
        },
        // 跳转到课程详情
        jumpDetail(item) {
            if (!this.loginUserInfo) {
                return window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${this.school_code}&from=${window.location.href}`, "_self")
            }
            if (this.studyBan) return Message.error("您暂无权限学习")

            // window.open(`/center/${this.school_code}/video/${item.id}/0?from=${this.$route.path}&id=0`, "_blank")
            window.open(`/center/${this.school_code}/class/${item.id}`, "_target")
        },
        handleScroll() {
            let that = this
            that.$nextTick(() => {
                let scrollTop = window.scrollY;
                that.isFixed = scrollTop + 40 >= that.windowHeight ? true : false
                if (that.$refs['ref-1'] && that.$refs['ref-2'] && that.$refs['ref-3'] && that.$refs['ref-4'] && that.$refs['ref-5']) {
                    if (that.$refs['ref-1'] && that.$refs['ref-2'] && that.$refs['ref-4'] && that.$refs['ref-5']) {
                        let div1 = that.$refs['ref-1'] && that.$refs['ref-1'].getBoundingClientRect().top + 50
                        let div2 = that.$refs['ref-2'] && that.$refs['ref-2'].getBoundingClientRect().top + 50
                        let div3 = that.$refs['ref-3'] && that.$refs['ref-3'].getBoundingClientRect().top + 50
                        let div4 = that.$refs['ref-4'] && that.$refs['ref-4'].getBoundingClientRect().top + 50
                        let div5 = that.$refs['ref-5'] && that.$refs['ref-5'].getBoundingClientRect().top + 50

                        if ((div1 + that.windowHeight / 3) > 0) {
                            that.isFixedId = 1
                        } else if ((div2 + that.windowHeight / 3) > 0) {
                            that.isFixedId = 2
                        } else if ((div3 + that.windowHeight / 3) > 0) {
                            that.isFixedId = 3
                        } else if ((div4 + that.windowHeight / 3) > 0) {
                            that.isFixedId = 4
                        } else if ((div5 + that.windowHeight / 3) > 0) {
                            that.isFixedId = 5
                        } else {
                            that.isFixedId = 1
                        }
                    }
                }
                that.isFixed = scrollTop >= 550 ? true : false
            })
        },
        scrollToSection(id) {
            document.getElementById(`section${id}`).scrollIntoView(true);
            this.isFixedId = id
        },
        autoHdfcActive() {
            let that = this
            if (that.hdfcActiveTimer) clearInterval(that.hdfcActiveTimer)
            that.hdfcActiveTimer = setInterval(() => {
                if (that.hdfcActive < (that.hdfcData.length - 1)) {
                    that.hdfcActive++
                } else {
                    that.hdfcActive = 0
                }
            }, 5000)
        },
        handleHdfcActive(ind) {
            this.hdfcActive = ind
            this.autoHdfcActive()
        },
        // 退出登录
        logoutEvents() {
            if (window.location.href.indexOf("hzvtc/detail") > -1) {
                localStorage.setItem("eol-hzvtc-detail-key", this.$route.query.key)
            }
            this.requestAppsLogout()
        },
        // 点击登录
        handleLogin() {
            window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${this.school_code}&from=${window.location.href}`, "_self")
        },
    },
    computed: {
        ...mapState({
            loginUserInfo: (state) => state.appsLogin.appsUserInfo,
            schoolInfo: (state) => state.appsLogin.schoolInfo,
        }),
    },

}
</script>

<style scoped lang="less">
::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

::-webkit-scrollbar-track-piece {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background: #d8e8e7;
    border-radius: 10px;
}

::-webkit-scrollbar-corner {
    background-color: transparent;
}

::-webkit-scrollbar-track {
    background-color: transparent;
}

.container {
    width: 1200px;
    margin: 0 auto;
}

.content-container {
    width: 100%;
    background: linear-gradient(90deg, #e3f1ff 0%, #eafeff 100%);

    .swiper-container {
        height: 100%;
    }

    .banner-swiper {
        width: 100%;
        height: 500px;
        position: relative;

        .thumb-image {
            height: 100%;
        }

        .swiper-pagination-1 {
            width: 100%;
            text-align: center;
            position: absolute;
            bottom: 21px;
            z-index: 1;

            ::v-deep .swiper-pagination-bullet {
                display: inline-block;

                &.swiper-pagination-bullet-active {
                    width: 20px;
                    height: 10px;
                    background: #ffffff;
                    border-radius: 5px;
                    border: 1px solid #039881;
                }

                width: 6px;
                height: 6px;
                background: #039881;
                border-radius: 50%;
                vertical-align: middle;

                &:not(:last-child) {
                    margin-right: 8px;
                }
            }
        }
    }

    .ssap-box {
        padding-top: 30px;

        .header {
            width: 533px;
            height: 105px;
            background: url('../../../assets/custom/clnyy/header-ssap.png') no-repeat center/cover;
            margin: 0 auto 42px;
        }

        .content {
            &>div {
                display: flex;
            }

            &::before {
                position: absolute;
                top: -6px;
                left: 50%;
                transform: translateX(-50%);
                content: '';
                display: inline-block;
                width: 1220px;
                height: 6px;
                background: linear-gradient(90deg, #5791ef 0%, #4cb1a0 100%);
            }

            position: relative;
            padding: 24px 29px 40px 0;
            background: #ffffff;
            border-radius: 0px 0px 10px 10px;

            .label {
                flex-shrink: 0;
                width: 142px;
                height: 47px;
                line-height: 60px;
                font-weight: bold;
                font-size: 16px;
                color: #ffffff;
                background: url('../../../assets/custom/clnyy/ssap-label.png') no-repeat center/cover;
                text-indent: 18px;
                margin-right: 15px;
                transform: translateX(-10px);
            }

            .hdjj {
                padding-top: 5px;
            }

            .hdbj,
            .hdjj {
                .con {
                    padding-top: 4px;
                    flex: 1;
                    font-size: 14px;
                    color: #42484c;
                    line-height: 30px;
                    padding-bottom: 12px;
                    border-bottom: 1px solid #f3f6f6;
                }
            }

            .zzjg {
                padding-top: 18px;
                align-items: center;
                margin-bottom: 18px;

                .label {
                    transform: translate(-10px; -22px);
                }

                .con {
                    padding-left: 20px;
                    width: 100%;
                    background: #f3f7ff;
                    font-size: 14px;
                    color: #0d4bac;
                    position: relative;
                    padding: 8px 0 8px 20px;
                    line-height: 25px;

                    &::after {
                        position: absolute;
                        left: 0;
                        bottom: -18px;
                        content: '';
                        display: inline-block;
                        width: 100%;
                        height: 1px;
                        background: #f3f6f6;
                    }
                }
            }

            .sjap {
                .con {
                    margin-top: 12px;
                    width: 1014px;
                    background: #ffffff;
                    border: 1px solid #d9e8e6;

                    .current-box {
                        display: flex;
                        justify-content: space-between;

                        .current-item {
                            width: 262px;
                            height: 44px;
                            line-height: 44px;
                            display: flex;
                            justify-content: center;
                            cursor: pointer;
                            flex-shrink: 0;
                            position: relative;

                            &:nth-child(1) {
                                transform: translateX(-2px);
                            }

                            &:nth-child(2) {
                                transform: translateX(-13px);
                            }

                            &:nth-child(3) {
                                transform: translateX(-24px);
                            }

                            &:nth-child(4) {
                                transform: translateX(-34px);
                            }

                            .name {
                                font-weight: bold;
                                font-size: 17px;
                                margin-right: 10px;
                                color: #333333;
                                position: relative;
                            }

                            .date {
                                font-size: 14px;
                                color: #6d7d86;
                            }

                            background: url('../../../assets/custom/clnyy/arrow-02.png') no-repeat center/cover;

                            &.active {
                                background: url('../../../assets/custom/clnyy/arrow-02-active.png') no-repeat center/cover !important;
                                height: 53px;

                                .name,
                                .date {
                                    color: #fff;
                                }
                            }

                            &:hover {
                                background: url('../../../assets/custom/clnyy/arrow-2-hover.png') no-repeat center/cover;
                            }

                            &.flag {
                                .name::before {
                                    content: '';
                                    display: inline-block;
                                    position: absolute;
                                    top: 14px;
                                    right: 100%;
                                    width: 16px;
                                    height: 17px;
                                    background: url('../../../assets/custom/clnyy/ssap-active.png') no-repeat center/cover;
                                }
                            }

                            &:first-child {
                                background: url('../../../assets/custom/clnyy/arrow-01.png') no-repeat center/cover;

                                &.active {
                                    background: url('../../../assets/custom/clnyy/arrow-01-active.png') no-repeat center/cover !important;
                                }

                                &:hover {
                                    background: url('../../../assets/custom/clnyy/arrow-1-hover.png') no-repeat center/cover;
                                }
                            }

                            &:last-child {
                                background: url('../../../assets/custom/clnyy/arrow-03.png') no-repeat center/cover;

                                &.active {
                                    background: url('../../../assets/custom/clnyy/arrow-03-active.png') no-repeat center/cover !important;
                                }

                                &:hover {
                                    background: url('../../../assets/custom/clnyy/arrow-3-hover.png') no-repeat center/cover;
                                }
                            }
                        }
                    }

                    .con-box {
                        .current-content {
                            height: 232px;

                            &.bmjd {
                                padding: 18px 0 30px;

                                .line-type-1 {
                                    display: flex;
                                    align-items: center;
                                    height: 28px;
                                    background: linear-gradient(90deg,
                                            #eff4ff 0%,
                                            rgba(239, 244, 255, 0.3) 100%);

                                    &:not(:last-child) {
                                        margin-bottom: 4px;
                                    }

                                    .sub-label {
                                        text-indent: 21px;
                                        width: 104px;
                                        height: 100%;
                                        background: linear-gradient(90deg,
                                                rgba(77, 126, 204, 0.54) 0%,
                                                rgba(76, 177, 160, 0.54) 65%);
                                        border-radius: 0px 14px 14px 0px;
                                        color: #fff;
                                        font-size: 14px;
                                        font-weight: bold;
                                        line-height: 28px;
                                    }

                                    .text {
                                        padding-left: 16px;
                                        font-size: 14px;
                                        color: #4b6965;
                                        line-height: 28px;
                                    }
                                }

                                .line-type-2 {
                                    padding: 0 41px 0 20px;
                                    margin-top: 30px;
                                    display: flex;
                                    justify-content: space-between;

                                    .l {
                                        position: relative;
                                        padding-right: 26px;

                                        &::before {
                                            content: '';
                                            display: inline-block;
                                            width: 1px;
                                            height: 86px;
                                            background: #d4e2e0;
                                            position: absolute;
                                            right: 0;
                                            top: 50%;
                                            transform: translateY(-50%);
                                        }

                                        .name {
                                            font-weight: bold;
                                            font-size: 16px;
                                            color: #0d4bac;
                                            line-height: 1;
                                        }

                                        .href {
                                            display: flex;
                                            align-items: center;
                                            margin: 18px 0 11px;

                                            span {
                                                display: block;
                                                width: 674px;
                                                height: 30px;
                                                background: #ffffff;
                                                border: 1px solid #dfe4e6;
                                                line-height: 30px;
                                                font-size: 14px;
                                                color: #7f8589;
                                                padding-left: 12px;
                                            }

                                            a {
                                                display: block;
                                                width: 48px;
                                                height: 30px;
                                                background: #3884fc;
                                                font-size: 14px;
                                                color: #fff;
                                                font-weight: bold;
                                                text-align: center;
                                                line-height: 30px;
                                            }
                                        }

                                        .copy {
                                            display: inline-block;
                                            cursor: pointer;
                                            line-height: 1;
                                            font-size: 14px;
                                            color: #0d4bac;
                                        }
                                    }

                                    .r {
                                        display: flex;
                                        align-items: center;

                                        img {
                                            flex-shrink: 0;
                                            width: 86px;
                                            margin-right: 14px;
                                        }

                                        span {
                                            font-size: 14px;
                                            color: #353a3d;
                                            line-height: 20px;
                                        }
                                    }
                                }
                            }

                            &.pt93 {
                                padding-top: 93px !important;
                            }

                            &.type-2 {
                                padding: 52px 114px 0;
                                position: relative;

                                .time-name {
                                    position: absolute;
                                    top: 25px;
                                    left: 50%;
                                    transform: translateX(-50%);
                                    width: 230px;
                                    height: 46px;
                                    background: linear-gradient(90deg,
                                            rgba(87, 145, 239, 0.54) 0%,
                                            rgba(76, 177, 160, 0.54) 65%);
                                    border-radius: 14px;
                                    text-align: center;
                                    line-height: 46px;
                                    font-weight: bold;
                                    font-size: 17px;
                                    color: #ffffff;

                                    &::before {
                                        content: '';
                                        display: inline-block;
                                        position: absolute;
                                        top: 100%;
                                        left: 50%;
                                        transform: translateX(-50%);
                                        width: 1px;
                                        height: 34px;
                                        border: 1px solid #e3e7e8;
                                    }
                                }

                                .time-line {
                                    width: 100%;
                                    height: 1px;
                                    background: #ebecec;
                                }

                                .time-items {
                                    display: flex;
                                    justify-content: space-between;

                                    .items {
                                        padding-top: 34px;
                                        text-align: center;
                                        position: relative;

                                        &::before {
                                            content: '';
                                            display: inline-block;
                                            position: absolute;
                                            top: 0;
                                            left: 50%;
                                            transform: translateX(-50%);
                                            width: 1px;
                                            height: 34px;
                                            border: 1px solid #e3e7e8;
                                        }

                                        &::after {
                                            content: '';
                                            display: inline-block;
                                            position: absolute;
                                            top: -5px;
                                            left: 50%;
                                            transform: translateX(-50%);

                                            width: 10px;
                                            height: 10px;
                                            background: linear-gradient(90deg,
                                                    #5791ef 0%,
                                                    #4cb1a0 65%);
                                            border-radius: 50%;
                                        }

                                        .date {
                                            width: 160px;
                                            height: 28px;
                                            background: linear-gradient(90deg,
                                                    rgba(87, 145, 239, 0.54) 0%,
                                                    rgba(76, 177, 160, 0.54) 65%);
                                            border-radius: 14px;
                                            line-height: 28px;
                                            font-weight: bold;
                                            font-size: 14px;
                                            color: #ffffff;
                                        }

                                        .name {
                                            font-weight: bold;
                                            font-size: 16px;
                                            color: #353a3d;
                                            line-height: 1;
                                            padding-top: 22px;
                                        }

                                        .name-2 {
                                            width: 204px;
                                            height: 46px;
                                            background: #ffffff;
                                            border: 1px solid;
                                            border-image: linear-gradient(45deg,
                                                    rgba(3, 119, 165, 0.4),
                                                    rgba(206, 236, 254, 0.4),
                                                    rgba(216, 255, 249, 0.4),
                                                    rgba(3, 152, 129, 0.4)) 10 10;
                                            text-align: center;
                                            line-height: 46px;
                                            font-weight: bold;
                                            font-size: 16px;
                                            color: #353a3d;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .hdsh {
                margin-top: 22px;

                .con {
                    margin-top: 13px;
                    flex: 1;
                    height: 34px;
                    background: url('../../../assets/custom/clnyy/ssap-text.png') no-repeat center/cover;
                }
            }
        }
    }

    .dsdt-box {
        padding-top: 36px;

        .header {
            width: 448px;
            height: 60px;
            margin: 0 auto;
            background: url('../../../assets/custom/clnyy/header-dsdt.png') no-repeat center/cover;
        }

        .content {
            .select-box {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 30px;

                .select-item {
                    width: 208px;
                    height: 46px;
                    background: url('../../../assets/custom/clnyy/dsdt-title.png') no-repeat center/cover;
                    font-weight: bold;
                    font-size: 17px;
                    color: #117aaf;
                    text-align: center;
                    line-height: 40px;
                    cursor: pointer;

                    &:not(:last-child) {
                        margin-right: 23px;
                    }

                    &.active {
                        background: url('../../../assets/custom/clnyy/dsdt-title-active.png') no-repeat center/cover;
                        color: #ffffff;
                    }
                }
            }

            .content-box {
                margin-top: 34px;
                min-height: 510px;
                display: flex;

                .aside {
                    width: 390px;

                    .aside-header {
                        width: 100%;
                        height: 34px;
                        background: url('../../../assets/custom/clnyy/dsdt-aside-head.png') no-repeat center/cover;
                    }

                    .aside-content {
                        position: relative;
                        padding: 39px 0 49px 15px;

                        &::before {
                            position: absolute;
                            top: 0;
                            left: 0;
                            content: '';
                            display: inline-block;
                            width: 1200px;
                            height: 473px;
                            background: linear-gradient(90deg,
                                    #f4fafa 0%,
                                    #e8f6ff 51%,
                                    #dcf8f9 100%);
                            border: 2px solid;
                            opacity: 0.5;
                            border-image: linear-gradient(45deg,
                                    #0377a5,
                                    #ceecfe,
                                    #d8fff9,
                                    #039881) 10 10;
                        }

                        .aside-scroll {
                            transform: rotateY(180deg);
                            width: 100%;
                            height: 420px;
                            overflow-y: auto;
                            overflow-x: initial;

                            .item {
                                transform: rotateY(180deg) translateX(-15px);
                                cursor: pointer;
                                position: relative;
                                padding: 16px 28px 0 20px;
                                z-index: 1;
                                width: 344px;
                                font-size: 17px;
                                color: #353a3d;
                                line-height: 28px;
                                padding-bottom: 20px;
                                border-bottom: 1px solid #d9d9d9;

                                &.active {
                                    background: linear-gradient(90deg,
                                            #5791ef 0%,
                                            #4cb1a0 100%);
                                    color: #ffffff;

                                    &::before {
                                        content: '';
                                        display: inline-block;
                                        border: 13px solid #4cb1a0;
                                        border-top: 13px solid transparent;
                                        border-bottom: 13px solid transparent;
                                        border-right: 13px solid transparent;
                                        position: absolute;
                                        top: 50%;
                                        transform: translateY(-50%);
                                        right: -26px;
                                    }
                                }
                            }
                        }
                    }
                }

                .cont {
                    position: relative;
                    width: 790px;
                    background: #ffffff;
                    border: 1px solid #c0c6c5;
                    padding: 20px 10px 5px 40px;
                    height: 492px;

                    div {
                        height: 455px;
                        padding-right: 30px;
                        font-size: 14px;
                        color: #353a3d;
                        line-height: 24px;
                        text-indent: 28px !important;
                        overflow-y: auto;

                        /deep/ * {
                            line-height: 34px !important;
                        }

                        /deep/ img {
                            display: block;
                            max-width: 70%;
                            margin: 0 auto;
                        }

                        /deep/ a {
                            text-decoration: underline;
                            color: #125cfb;
                        }

                        /deep/ table {
                            width: 70%;
                            margin: 15px auto;

                            &,
                            tr,
                            td,
                            th {
                                border: 1px solid #000;
                            }

                            td,
                            th {
                                text-align: center;
                                padding: 8px;
                                line-height: 1.5 !important;
                            }
                        }

                        /deep/ .imgGroup {
                            text-indent: 0;
                            text-align: center;
                            margin: 15px 0;

                            img {
                                display: inline-block;
                                height: 200px;
                                width: auto;
                                max-width: 38%;

                                &:not(:last-child) {
                                    margin-right: 10px;
                                }
                            }

                            &.moreLine {
                                margin: 0;

                                img {
                                    max-width: 25%;
                                    height: 132px;
                                    margin: 0 10px 15px 0;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .zxkc-box {
        .header {
            width: 533px;
            height: 105px;
            margin: 0 auto;
            background: url('../../../assets/custom/clnyy/header-zxkc.png') no-repeat center/cover;
        }

        .cate-box {
            padding: 22px 0 16px;
            font-size: 14px;
            color: #5e656c;

            .cate-list-item {
                display: flex;

                .tag {
                    cursor: pointer;
                }

                &.level-1 {
                    margin-bottom: 16px;

                    .cate-item {
                        .tag {
                            width: 157px;
                            height: 45px;
                            text-align: center;
                            line-height: 42px;
                            background: url('../../../assets/custom/clnyy/cate.png') no-repeat center/cover;
                            font-weight: bold;
                            font-size: 17px;
                            color: #117aaf;

                            &:first-child {
                                letter-spacing: 9px;
                            }

                            &:not(:last-child) {
                                margin-right: 50px;
                            }

                            &.active {
                                background: url('../../../assets/custom/clnyy/cate-active.png') no-repeat center/cover;
                                color: #fff;
                            }
                        }
                    }
                }

                &.level-2 {
                    width: 100%;
                    height: 44px;
                    background: linear-gradient(90deg,
                            rgba(200, 222, 255, 0) 0%,
                            rgba(200, 222, 255, 0.28) 50%,
                            rgba(200, 222, 255, 0) 100%);
                    border: 2px solid transparent;
                    // border-image: linear-gradient(90deg, #ffffff, #ffffff) 10 10;
                    border-image: linear-gradient(90deg,
                            rgba(255, 255, 255, 0) 0%,
                            rgba(255, 255, 255, 1) 47%,
                            rgba(255, 255, 255, 0) 100%) 30 30;

                    .cate-item {
                        .tag {
                            &:first-child {
                                letter-spacing: 5px;
                            }

                            &:not(:last-child) {
                                margin-right: 62px;
                            }

                            font-size: 14px;
                            color: #42484c;
                            height: 28px;
                            line-height: 28px;
                            padding: 0 26px;
                            border-radius: 14px;

                            &.active {
                                background: #f2faff;
                                color: #117aaf;
                            }
                        }
                    }
                }

                .cate-item {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-wrap: wrap;
                }
            }
        }

        .class-lists {
            width: 100%;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding-bottom: 23px;
        }

        .class-lists .sub-visibility {
            flex: 0 0 278px;
            display: inline-block;
            overflow: visible;
        }

        .class-box {
            overflow: hidden;
            flex: 0 0 278px;
            float: left;
            background: #fff;
            cursor: pointer;
            margin-bottom: 20px;

            // border-radius: 8px;
            &:hover {
                box-shadow: 1px 2px 7px #ececec;
                transition: 0.3s box-shadow;

                .txt .title {
                    color: #364c7e;
                }
            }

            .link-box {
                display: inline-block;
            }

            .img {
                height: 156px;
                width: 100%;
                overflow: hidden;

                // border-radius: 8px 8px 0 0;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    margin: 0 auto;
                }
            }

            .txt {
                border: 1px solid #e1e7ea;
                height: 70px;
                width: 100%;
                padding: 11px 20px;
                box-sizing: border-box;

                .title {
                    font-size: 14px;
                    line-height: 20px;
                    color: #3a3a3a;
                    // overflow: hidden;
                    text-overflow: ellipsis;
                    // display: -webkit-box;
                    // -webkit-line-clamp: 2;
                    // -webkit-box-orient: vertical;
                    overflow: hidden;
                    white-space: nowrap;
                }

                .num {
                    font-size: 12px;
                    color: #959595;
                    margin-top: 5px;

                    .iconduoren {
                        font-size: 17px;
                        margin-top: 7px;
                        vertical-align: -1px;
                        margin-right: 5px;
                        color: #d5d5d5;
                    }

                    .courseFont {
                        width: 12px;
                        height: 13px;
                        margin-right: 5px;
                        display: inline-block;
                        vertical-align: -1px;
                        background-image: url('../../../assets/custom/clnyy/times-icon.png');
                        background-repeat: no-repeat;
                        background-size: 100% auto;
                    }
                }
            }
        }
    }

    .background {
        width: 100%;
        background: url('../../../assets/custom/clnyy/b-background.png') no-repeat center/cover;
        padding-bottom: 45px;

        .nyyjs-box {
            padding-top: 25px;

            .header {
                width: 533px;
                height: 106px;
                background: url('../../../assets/custom/clnyy/header-bjclnyyjs.png') no-repeat center/cover;
                margin: 0 auto 27px;
            }

            .content {
                position: relative;
                margin-top: 27px;
                height: 530px;
                display: flex;
                align-items: center;

                .swiper-imgs {
                    width: 600px;
                    height: 450px;
                    border: 6px solid;
                    border-image: linear-gradient(45deg,
                            #0377a5,
                            #ceecfe,
                            #d8fff9,
                            #039881) 10 10;
                    position: relative;
                    z-index: 1;

                    .swiper-container {
                        width: 100%;
                        height: 100%;
                    }

                    /deep/ .swiper-pagination-2 {
                        position: absolute;
                        bottom: 0;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 104px;
                        height: 32px;
                        background: linear-gradient(90deg,
                                #8cc5e2 0%,
                                #d8f5fe 100%);
                        border-radius: 10px 10px 0px 0px;
                        border: 0px solid #000000;
                        z-index: 1;
                        text-align: center;
                        line-height: 32px;

                        .swiper-pagination-bullet {
                            display: inline-block;
                            width: 8px;
                            height: 8px;
                            background: #039881;
                            border-radius: 50%;
                            border: 1px solid #ffffff;
                            vertical-align: middle;

                            &:not(:last-child) {
                                margin-right: 5px;
                            }

                            &.swiper-pagination-bullet-active {
                                border: 1px solid #039881;
                                width: 20px;
                                height: 10px;
                                background: #ffffff;
                                border-radius: 5px;
                            }
                        }
                    }

                    /deep/ .swiper-button-prev,
                    /deep/ .swiper-button-next {
                        width: 48px;
                        height: 48px;
                        background: rgba(3, 41, 36, 0.5);
                        border-radius: 50%;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        z-index: 1;
                        cursor: pointer;

                        &::before {
                            content: '';
                            display: inline-block;
                            position: absolute;
                            top: 50%;
                            transform: translate(-50%, -50%);
                            width: 18px;
                            height: 22px;
                        }

                        &:hover {
                            background: rgba(3, 41, 36, 0.68);
                        }
                    }

                    /deep/ .swiper-button-prev {
                        left: -22px;

                        &::before {
                            background: url('../../../assets/custom/clnyy/swiper-prev.png') no-repeat center/cover;
                            left: 20px;
                        }
                    }

                    /deep/ .swiper-button-next {
                        right: -22px;

                        &::before {
                            right: 4px;
                            background: url('../../../assets/custom/clnyy/swiper-next.png') no-repeat center/cover;
                        }
                    }
                }

                .text {
                    padding: 75px 24px 80px 110px;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    right: 0;
                    width: 690px;
                    height: 100%;
                    background: url('../../../assets/custom/clnyy/bjclnyyjs-bg.png') no-repeat center/cover;

                    .text-scroll {
                        height: 100%;
                        overflow-y: auto;
                        font-size: 16px;
                        color: #353a3d;
                        line-height: 30px;
                        padding-right: 26px;
                        text-indent: 2rem;

                        &::-webkit-scrollbar {
                            width: 5px;
                            height: 5px;
                        }

                        &::-webkit-scrollbar-track-piece {
                            background: transparent;
                        }

                        &::-webkit-scrollbar-thumb {
                            background: #a8c0df;
                            border-radius: 10px;
                        }

                        &::-webkit-scrollbar-corner {
                            background-color: transparent;
                        }

                        &::-webkit-scrollbar-track {
                            background-color: transparent;
                        }

                        p {
                            margin-bottom: 15px;
                        }

                        b {
                            color: #185770;
                            font-weight: bold;
                        }
                    }
                }
            }

            .list-imgs {
                margin-top: 30px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .item {
                    width: 285px;
                    height: 310px;
                    background: #ffffff;
                    padding: 24px 24px 0 14px;
                    position: relative;
                    overflow: hidden;

                    &.down {
                        .img {
                            height: 90px;
                        }

                        .text {
                            height: auto;
                            margin-top: 10px;
                            overflow: initial;
                        }

                        .more {
                            margin-top: 3px;
                        }
                    }

                    &::before {
                        content: '';
                        display: inline-block;
                        width: 100%;
                        height: 4px;
                        background: linear-gradient(90deg,
                                #5791ef 0%,
                                #4cb1a0 100%);
                        position: absolute;
                        top: 0;
                        left: 0;
                    }

                    .img {
                        width: 100%;
                        height: 146px;
                        transition: all 0.3s;
                        background-repeat: no-repeat;
                        background-position: top;
                        background-size: cover;
                    }

                    .text {
                        transition: all 0.3s;
                        margin-top: 23px;
                        height: 92px;
                        background: #fff;
                        font-size: 14px;
                        color: #61696e;
                        overflow: hidden;
                        line-height: 24px;
                    }

                    .more {
                        font-size: 14px;
                        color: #3884fc;
                        text-align: right;
                        cursor: pointer;
                        transition: all 0.3s;
                    }
                }
            }

            .description {
                padding-top: 27px;
                text-align: center;
                font-weight: bold;
                font-size: 16px;
                color: #247b6c;
                line-height: 28px;
            }
        }

        .wqhd-box {
            padding-top: 35px;

            .header {
                width: 448px;
                height: 60px;
                background: url('../../../assets/custom/clnyy/header-wqhdfc.png') no-repeat center/cover;
                margin: 0 auto 28px;
            }

            .content {
                .intro {
                    width: 100%;
                    height: 116px;
                    position: relative;

                    .intro-background {
                        position: absolute;
                        left: 0;
                        top: 0;
                        display: inline-block;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(90deg,
                                rgba(231, 245, 255, 0) 0%,
                                rgba(232, 246, 255, 0.98) 51%,
                                rgba(236, 252, 252, 0) 100%);
                        border: 2px solid #ffffff;

                        &::before {
                            content: '';
                            display: inline-block;
                            width: 322px;
                            height: 34px;
                            background: linear-gradient(90deg,
                                    #5791ef 0%,
                                    #4cb1a0 65%,
                                    rgba(206, 233, 253, 0) 100%);
                            position: absolute;
                            top: 0;
                            left: 0;
                        }

                        &::after {
                            content: '';
                            display: inline-block;
                            background: url('../../../assets/custom/clnyy/text-shsjkphdjs.png') no-repeat center/cover;
                            width: 224px;
                            height: 17px;
                            position: absolute;
                            top: 9px;
                            left: 33px;
                        }
                    }

                    .intro-text {
                        font-size: 16px;
                        color: #353a3d;
                        line-height: 30px;
                        position: relative;
                        z-index: 1;
                        padding: 44px 35px 0;
                    }
                }

                .intro-idea {
                    margin-top: 8px;
                    width: 100%;
                    height: 191px;
                    background: linear-gradient(90deg,
                            rgba(231, 245, 255, 0) 0%,
                            rgba(232, 246, 255, 0.98) 51%,
                            rgba(236, 252, 252, 0) 100%);
                    display: flex;
                    align-items: center;

                    .label {
                        flex-shrink: 0;
                        position: relative;
                        width: 34px;
                        height: 154px;
                        background: linear-gradient(180deg,
                                #5791ef 0%,
                                #4cb1a0 65%,
                                rgba(206, 233, 253, 0) 100%);

                        &::before {
                            content: '';
                            display: inline-block;
                            position: absolute;
                            top: 23px;
                            left: 7px;
                            background: url('../../../assets/custom/clnyy/text-kcln.png') no-repeat center/cover;
                            width: 20px;
                            height: 89px;
                        }
                    }

                    .lists {
                        display: flex;
                        align-items: center;
                        flex: 1;

                        .item {
                            padding-left: 50px;
                            position: relative;
                            flex: 1;

                            b {
                                font-weight: bold;
                                font-size: 18px;
                                color: #2859a1;
                                line-height: 28px;
                                display: block;
                            }

                            .text {
                                margin-top: 20px;
                                width: 280px;
                                font-size: 14px;
                                color: #61696e;
                                line-height: 22px;
                            }

                            &:not(:last-child):before {
                                content: '';
                                display: inline-block;
                                width: 1px;
                                height: 131px;
                                background: #c3d5d2;
                                position: absolute;
                                top: 50%;
                                transform: translateY(-50%);
                                right: 0;
                            }

                            &:first-child::after {
                                content: '';
                                display: inline-block;
                                width: 136px;
                                height: 131px;
                                background: url('../../../assets/custom/clnyy/wqhdfc-01.png') no-repeat center/cover;
                                position: absolute;
                                top: 50%;
                                transform: translateY(-50%);
                                right: 17px;
                            }

                            &:nth-child(2)::after {
                                content: '';
                                display: inline-block;
                                width: 122px;
                                height: 136px;
                                background: url('../../../assets/custom/clnyy/wqhdfc-02.png') no-repeat center/cover;
                                position: absolute;
                                top: 50%;
                                transform: translateY(-50%);
                                right: 17px;
                            }

                            &:last-child::after {
                                content: '';
                                display: inline-block;
                                width: 172px;
                                height: 136px;
                                background: url('../../../assets/custom/clnyy/wqhdfc-03.png') no-repeat center/cover;
                                position: absolute;
                                top: 50%;
                                transform: translateY(-50%);
                                right: 17px;
                            }
                        }
                    }
                }

                .intro-video {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 17px;

                    .video-box {
                        width: 600px;
                        height: 340px;
                        border: 2px solid #ffffff;

                        video {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .text-content {
                        width: 583px;
                        height: 340px;
                        background: #ffffff;
                        border: 2px solid;
                        border-image: linear-gradient(0deg,
                                #f6faf9,
                                #ffffff,
                                #f9ffff) 10 10;
                        display: flex;
                        align-items: center;

                        .select-box {
                            height: 100%;
                            display: flex;

                            .item {
                                width: 48px;
                                height: 100%;
                                border: 2px solid #ffffff;
                                text-align: center;
                                line-height: 48px;
                                writing-mode: vertical-lr;
                                cursor: pointer;
                                background: linear-gradient(180deg,
                                        rgba(87, 145, 239, 0.3) 0%,
                                        rgba(76, 177, 160, 0.3) 100%);
                                font-weight: bold;
                                font-size: 16px;
                                color: #191b47;

                                &.active {
                                    background: linear-gradient(180deg,
                                            #5791ef 0%,
                                            #4cb1a0 100%);
                                    color: #ffffff;
                                }
                            }
                        }

                        .word-box {
                            height: 100%;
                            padding: 20px 24px;
                            font-size: 14px;
                            color: #61696e;
                            line-height: 28px;
                            position: relative;

                            &::before {
                                content: '';
                                display: inline-block;
                                position: absolute;
                                top: 0;
                                right: 0;
                                width: 130px;
                                height: 97px;
                                background: url('../../../assets/custom/clnyy/wqhdtc-t-r.png') no-repeat center/cover;
                            }

                            /deep/ p,
                            /deep/ img {
                                position: sticky;
                                z-index: 1;
                            }

                            /deep/ img {
                                max-width: 100%;
                                display: block;
                                margin: 12px 0 auto;
                            }
                        }
                    }
                }
            }
        }
    }
}

.fixed-slider {
    width: 165px;
    position: absolute;
    top: 708px;
    left: 50px;
    z-index: 100;
    background: linear-gradient(45deg, #ebf5ff 0%, #ffffff 50%, #e9fcff 100%);
    box-shadow: 0px 2px 10px 0px rgba(130, 139, 144, 0.33);
    border: 1px solid;
    border-image: linear-gradient(45deg, #0377a5, #ceecfe, #d8fff9, #039881) 10 10;

    &.fixed {
        position: fixed;
        top: 158px;
    }

    .slider-header {
        width: 100%;
        height: 50px;
        background: linear-gradient(90deg, #5791ef 0%, #4cb1a0 100%);
        position: relative;

        &::before {
            content: '';
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: url('../../../assets/custom/clnyy/aside-header.png') no-repeat center/cover;
            width: 58px;
            height: 18px;
        }
    }

    .slider-content {
        padding: 12px 19px 15px;

        .slider-item {
            display: block;
            font-weight: bold;
            font-size: 14px;
            color: #353a3d;
            position: relative;
            height: 45px;
            line-height: 45px;
            text-align: center;

            &:not(:last-child) {
                border-bottom: 1px solid #e1e5e5;
            }

            &::before {
                content: '';
                display: inline-block;
                width: 165px;
                height: 100%;
                background: url('../../../assets/custom/clnyy/slider-active.png') no-repeat center/cover;
                position: absolute;
                z-index: -1;
                top: 42%;
                transform: translateY(-50%);
                opacity: 0;
                left: -30px;
            }

            &.active {
                color: #ffffff;
                border: none;

                &::before {
                    opacity: 1;
                }
            }
        }
    }
}

@media screen and(max-width:1600px) {
    .fixed-slider {
        width: 130px;
        left: 0;

        .slider-content {
            overflow: hidden;
            padding: 12px 5px 15px;

            .slider-item {
                white-space: nowrap;
            }
        }
    }
}
</style>


<style lang="less" scoped>
.header-container {
    width: 100%;
    height: 50px;
    background: linear-gradient(90deg, #edfdfd 0%, #c0e3fe 100%);
    display: flex;
    align-items: center;

    .header-content {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100%;

        .info-box {
            display: flex;
            align-items: center;

            .school-logo {
                width: auto;

                img {
                    width: auto;
                    max-height: 34px;
                }
            }
        }

        .handle-box {
            display: flex;
            align-items: center;
            height: 100%;

            .login-btn {
                font-weight: bold;
                font-size: 16px;
                color: #0c9a47;
                cursor: pointer;
                line-height: 50px;
            }

            .eol-right-user {
                display: inline-block;
                vertical-align: top;
                margin-right: 30px;
                max-width: 260px;
                position: relative;
                height: 100%;
            }

            .eol-right-user .close-page-box {
                position: absolute;
                display: inline-block;
                font-size: 16px;
                color: #3a3a3a;
                display: inline-block;
                margin-left: 5px;
                top: 13px;
                left: -80px;
                cursor: pointer;
            }

            .eol-right-user .close-page-box img {
                vertical-align: -4px;
            }

            .eol-right-user .mine-lines {
                height: 100%;
                font-size: 14px;
                font-weight: 400;
                color: #125cfb;
                cursor: pointer;
                display: flex;
                align-items: center;
            }

            .eol-right-user .mine-lines span {
                vertical-align: middle;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: inline-block;
                max-width: 200px;
                margin: 0 16px 0 6px;
            }

            .eol-right-user .mine-lines::after {
                content: '';
                display: inline-block;
                width: 12px;
                height: 12px;
                background-image: url('../../../assets/site/header/icons-jiantou-down.png');
                background-repeat: no-repeat;
                background-size: 100% auto;
                margin-left: 4px;
            }

            .eol-right-user.up .mine-lines::after {
                -webkit-transform: rotate(180deg);
                transform: rotate(180deg);
                -webkit-transition: -webkit-transform 0.3s;
                transition: transform 0.3s;
            }

            .eol-right-user.down .mine-lines::after {
                -webkit-transform: rotate(0deg);
                transform: rotate(0deg);
                -webkit-transition: -webkit-transform 0.3s;
                transition: transform 0.3s;
            }

            .eol-right-user .user-imgs-box {
                display: inline-block;
                width: 20px;
                height: 20px;
                margin-right: 4px;
                vertical-align: middle;
                text-align: right;
                background: url('../../../assets/site/header/mine-icons.png') no-repeat center;
                background-size: 100% auto;
            }

            .eol-right-user .eol-submine-box {
                background: #ffffff;
                border: 1px solid #dfe3e4;
                position: absolute;
                z-index: 1000;
                top: 48px;
                right: -12px;
                padding: 18px 15px 18px 20px;
                text-align: left;
                display: none;
                min-width: 130px;
            }

            .eol-right-user.up .eol-submine-box {
                display: block;
            }

            .eol-right-user.down .eol-submine-box {
                display: none;
            }

            .eol-right-user .submine-items {
                height: 30px;
                color: #71737b;
                line-height: 30px;
                font-size: 14px;
                cursor: pointer;
            }

            .eol-right-user .submine-items a {
                display: block;
                width: auto;
                color: #71737b;
            }

            .eol-right-user .submine-items.active,
            .eol-right-user .submine-items:hover a {
                color: #3460e4;
                text-decoration: none;
            }

            .eol-right-user .mine-left-icons {
                width: 14px;
                height: 14px;
                margin-right: 6px;
                display: inline-block;
                vertical-align: -2px;
            }
        }
    }
}
</style>